export const throwResponseIfInvalid = (
  condition: boolean,
  message = "",
  statusCode = 404,
) => {
  if (!condition) {
    throw new Response(message, {
      status: statusCode,
    });
  }
};

export const getFirstTwoLetters = (name: string) => {
  const splitName = name.split(" ");
  if (splitName.length === 1) {
    return splitName[0].slice(0, 2);
  } else {
    return splitName[0].slice(0, 1) + splitName[1].slice(0, 1);
  }
};
